import { Injectable } from '@angular/core';
import { MonthlyTrueUpCalculationFilterRepresentation } from '../monthly-true-up-calculation-filter-representation-base';

@Injectable({ providedIn: 'root' })
export class TrueUpFilterStateService {
  private filters = new Map<string, MonthlyTrueUpCalculationFilterRepresentation>();

    constructor() {
    console.log(
      'InventoryFilterStateService instance created',
      Math.random()
    );
    }

  /** Get existing filter or create it once */
  getFilter(key: string): MonthlyTrueUpCalculationFilterRepresentation {
    if (!this.filters.has(key)) {
      this.filters.set(key, new MonthlyTrueUpCalculationFilterRepresentation());
    }
    return this.filters.get(key)!;
  }

  /** Explicitly overwrite a filter */
  setFilter(key: string, filter: MonthlyTrueUpCalculationFilterRepresentation): void {
    this.filters.set(key, filter);
  }

  /** Remove one filter */
  clearFilter(key: string): void {
    this.filters.delete(key);
  }

  /** Reset all filters (optional) */
  clearAll(): void {
    this.filters.clear();
  }
}